export var getShakaRestrictionsChecker = function(restrictions) {
    var _restrictions_minWidth = restrictions.minWidth, minWidth = _restrictions_minWidth === void 0 ? 0 : _restrictions_minWidth, _restrictions_maxWidth = restrictions.maxWidth, maxWidth = _restrictions_maxWidth === void 0 ? Infinity : _restrictions_maxWidth, _restrictions_minHeight = restrictions.minHeight, minHeight = _restrictions_minHeight === void 0 ? 0 : _restrictions_minHeight, _restrictions_maxHeight = restrictions.maxHeight, maxHeight = _restrictions_maxHeight === void 0 ? Infinity : _restrictions_maxHeight, _restrictions_minPixels = restrictions.minPixels, minPixels = _restrictions_minPixels === void 0 ? 0 : _restrictions_minPixels, _restrictions_maxPixels = restrictions.maxPixels, maxPixels = _restrictions_maxPixels === void 0 ? Infinity : _restrictions_maxPixels, _restrictions_minFrameRate = restrictions.minFrameRate, minFrameRate = _restrictions_minFrameRate === void 0 ? 0 : _restrictions_minFrameRate, _restrictions_maxFrameRate = restrictions.maxFrameRate, maxFrameRate = _restrictions_maxFrameRate === void 0 ? Infinity : _restrictions_maxFrameRate, _restrictions_minBandwidth = restrictions.minBandwidth, minBandwidth = _restrictions_minBandwidth === void 0 ? 0 : _restrictions_minBandwidth, _restrictions_maxBandwidth = restrictions.maxBandwidth, maxBandwidth = _restrictions_maxBandwidth === void 0 ? Infinity : _restrictions_maxBandwidth;
    return function(variant) {
        if (variant.video && variant.video.width && variant.video.height) {
            var _variant_video = variant.video, width = _variant_video.width, height = _variant_video.height;
            if (width < minWidth || width > maxWidth) {
                return false;
            }
            if (height < minHeight || height > maxHeight) {
                return false;
            }
            var pixelCount = width * height;
            if (pixelCount < minPixels || pixelCount > maxPixels) {
                return false;
            }
        }
        if (variant.video && variant.video.frameRate) {
            var frameRate = variant.video.frameRate;
            if (frameRate < minFrameRate || frameRate > maxFrameRate) {
                return false;
            }
        }
        if (variant.bandwidth < minBandwidth || variant.bandwidth > maxBandwidth) {
            return false;
        }
        return true;
    };
};

//# sourceMappingURL=shaka-abr-restrictions.js.map